import { brandInfo } from '@/mocks/anime';

export default function BrandIntro() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-10">
        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">
          关于樱花动漫网
        </h1>
        <p className="text-base md:text-lg text-foreground-300 max-w-3xl mx-auto leading-relaxed">
          {brandInfo.introduction}
        </p>
      </div>

      <div className="text-center mb-12">
        <p className="text-lg md:text-xl font-heading text-accent-400 italic">
          ❝ {brandInfo.mission} ❞
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12">
        {brandInfo.features.map((feature) => (
          <div
            key={feature.title}
            className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/50 text-center"
          >
            <h3 className="text-base font-heading font-semibold text-foreground-100 mb-2">
              {feature.title}
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
        {brandInfo.stats.map((stat) => (
          <div key={stat.label} className="text-center p-4">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400 mb-1">
              {stat.value}
            </div>
            <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}